import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useMutation } from '../../hooks/useApi';
import { useSession } from '../../session/SessionContext';
import { Card, Field } from '../../components/ui';
import { InlineError } from '../../components/ErrorView';
import { routes } from '../../api/routes';

interface LoginResult {
  /** The server asks for the second factor rather than the client guessing. */
  totp_required?: boolean;
}

export function Login() {
  const nav = useNavigate();
  const location = useLocation();
  const { refresh } = useSession();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const login = useMutation<Record<string, unknown>, LoginResult>(routes.auth.login);

  const from = (location.state as { from?: string } | null)?.from ?? '/bots';

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const res = await login.run({ email, password });
    if (!res) return;
    if (res.totp_required) {
      nav('/login/2fa', { state: { email, password, from } });
      return;
    }
    await refresh();
    nav(from, { replace: true });
  };

  return (
    <div className="narrow">
      <Card title="Sign in">
        <form onSubmit={submit}>
          <Field id="login-email" label="Email">
            <input
              id="login-email"
              className="input"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Field>
          <Field id="login-password" label="Password">
            <input
              id="login-password"
              className="input"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Field>
          {login.problem ? <InlineError problem={login.problem} /> : null}
          <button type="submit" className="btn btn-primary" disabled={login.pending}>
            {login.pending ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        <p className="muted">
          No account? <Link to="/signup">Create one</Link>.
        </p>
      </Card>
    </div>
  );
}
